import t, { useRef as J, useState as M, useSyncExternalStore as K, useMemo as z, useEffect as F, useCallback as U } from "react";
import { c as h, t as x, D as N } from "./app-a75c1d35.mjs";
import { g as I, n as Y, S as Z, a as w } from "./swiper.min-13551361.mjs";
import { I as ee, a as te } from "./Image-d6406817.mjs";
import { L as ae } from "./Link-479ac100.mjs";
import { B as O } from "./Button-c598cb52.mjs";
import { B as L } from "./Block-9b78bd10.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
import "./LinkContext-0c83848a.mjs";
import "./Icon-3122c134.mjs";
import "./useClickOutside-726e7c36.mjs";
function ne({
  swiper: e,
  extendParams: r,
  on: a,
  emit: o
}) {
  let d;
  e.autoplay = {
    running: !1,
    paused: !1
  }, r({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !0,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  function i() {
    if (!e.size) {
      e.autoplay.running = !1, e.autoplay.paused = !1;
      return;
    }
    const m = e.slides.eq(e.activeIndex);
    let u = e.params.autoplay.delay;
    m.attr("data-swiper-autoplay") && (u = m.attr("data-swiper-autoplay") || e.params.autoplay.delay), clearTimeout(d), d = Y(() => {
      let p;
      e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), p = e.slidePrev(e.params.speed, !0, !0), o("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? l() : (p = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), o("autoplay")) : (p = e.slidePrev(e.params.speed, !0, !0), o("autoplay")) : e.params.loop ? (e.loopFix(), p = e.slideNext(e.params.speed, !0, !0), o("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? l() : (p = e.slideTo(0, e.params.speed, !0, !0), o("autoplay")) : (p = e.slideNext(e.params.speed, !0, !0), o("autoplay")), (e.params.cssMode && e.autoplay.running || p === !1) && i();
    }, u);
  }
  function c() {
    return typeof d < "u" || e.autoplay.running ? !1 : (e.autoplay.running = !0, o("autoplayStart"), i(), !0);
  }
  function l() {
    return !e.autoplay.running || typeof d > "u" ? !1 : (d && (clearTimeout(d), d = void 0), e.autoplay.running = !1, o("autoplayStop"), !0);
  }
  function C(m) {
    e.autoplay.running && (e.autoplay.paused || (d && clearTimeout(d), e.autoplay.paused = !0, m === 0 || !e.params.autoplay.waitForTransition ? (e.autoplay.paused = !1, i()) : ["transitionend", "webkitTransitionEnd"].forEach((u) => {
      e.$wrapperEl[0].addEventListener(u, g);
    })));
  }
  function _() {
    const m = I();
    m.visibilityState === "hidden" && e.autoplay.running && C(), m.visibilityState === "visible" && e.autoplay.paused && (i(), e.autoplay.paused = !1);
  }
  function g(m) {
    !e || e.destroyed || !e.$wrapperEl || m.target === e.$wrapperEl[0] && (["transitionend", "webkitTransitionEnd"].forEach((u) => {
      e.$wrapperEl[0].removeEventListener(u, g);
    }), e.autoplay.paused = !1, e.autoplay.running ? i() : l());
  }
  function E() {
    e.params.autoplay.disableOnInteraction ? l() : (o("autoplayPause"), C()), ["transitionend", "webkitTransitionEnd"].forEach((m) => {
      e.$wrapperEl[0].removeEventListener(m, g);
    });
  }
  function T() {
    e.params.autoplay.disableOnInteraction || (e.autoplay.paused = !1, o("autoplayResume"), i());
  }
  function S() {
    e.params.autoplay.pauseOnMouseEnter && (e.$el.on("mouseenter", E), e.$el.on("mouseleave", T));
  }
  function k() {
    e.$el.off("mouseenter", E), e.$el.off("mouseleave", T);
  }
  a("init", () => {
    e.params.autoplay.enabled && (c(), I().addEventListener("visibilitychange", _), S());
  }), a("beforeTransitionStart", (m, u, p) => {
    e.autoplay.running && (p || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(u) : l());
  }), a("sliderFirstMove", () => {
    e.autoplay.running && (e.params.autoplay.disableOnInteraction ? l() : C());
  }), a("touchEnd", () => {
    e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && i();
  }), a("destroy", () => {
    k(), e.autoplay.running && l(), I().removeEventListener("visibilitychange", _);
  }), Object.assign(e.autoplay, {
    pause: C,
    run: i,
    start: c,
    stop: l
  });
}
function A(e, r = {}) {
  typeof window > "u" || !Array.isArray(window.dataLayer) || window.dataLayer.push({
    event: e,
    event_category: "testimonials",
    ...r
  });
}
const ie = "testimonial-card", se = "testimonial-card--featured", oe = "testimonial-card__image-container", le = "desktop", re = "testimonial-card__content-overlay", de = "testimonial-card__content", me = "mobile", ue = "testimonial-card__title", ce = "testimonial-card__title--featured", fe = "testimonial-card__numbering", pe = "testimonial-card__featured-body", ye = "testimonial-card__body", Ce = "testimonial-card__cta", ge = "testimonial-card__cta-button", ve = "testimonial-card__testimonial-section", he = "testimonial-card__quote-container", Ee = "testimonial-card__quote-mark", _e = "testimonial-card__testimonial-content", be = "testimonial-card__testimonial-text", Ne = "testimonial-card__author-info", Te = "testimonial-card__person-name", Be = "testimonial-card__company-name", s = {
  testimonialCard: ie,
  testimonialCardFeatured: se,
  testimonialCardImageContainer: oe,
  desktop: le,
  testimonialCardContentOverlay: re,
  testimonialCardContent: de,
  mobile: me,
  testimonialCardTitle: ue,
  testimonialCardTitleFeatured: ce,
  testimonialCardNumbering: fe,
  testimonialCardFeaturedBody: pe,
  testimonialCardBody: ye,
  testimonialCardCta: Ce,
  testimonialCardCtaButton: ge,
  testimonialCardTestimonialSection: ve,
  testimonialCardQuoteContainer: he,
  testimonialCardQuoteMark: Ee,
  testimonialCardTestimonialContent: _e,
  testimonialCardTestimonialText: be,
  testimonialCardAuthorInfo: Ne,
  testimonialCardPersonName: Te,
  testimonialCardCompanyName: Be
}, V = ({
  title: e,
  testimonialText: r,
  personName: a,
  companyName: o,
  image: d,
  variant: i = "quote",
  body: c,
  cta: l,
  index: C,
  total: _
}) => {
  const g = i === "featured", E = g && C && _ ? `${C}/${_}` : void 0, T = () => {
    A("testimonials_cta_click", {
      variant: i,
      card_title: e,
      card_index: C,
      card_total: _,
      cta_href: l?.href
    });
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: h(
        s.testimonialCard,
        g && s.testimonialCardFeatured
      ),
      "data-testid": "testimonial-card",
      "data-variant": i
    },
    /* @__PURE__ */ t.createElement("div", { className: s.testimonialCardImageContainer }, d && /* @__PURE__ */ t.createElement(
      ee,
      {
        ...d,
        styling: te.CARD
      }
    )),
    /* @__PURE__ */ t.createElement("div", { className: s.testimonialCardContentOverlay }, /* @__PURE__ */ t.createElement("div", { className: s.testimonialCardContent }, E && /* @__PURE__ */ t.createElement(
      "p",
      {
        className: s.testimonialCardNumbering,
        "data-testid": "testimonial-card-numbering"
      },
      E
    ), /* @__PURE__ */ t.createElement(
      "h3",
      {
        className: h(
          s.testimonialCardTitle,
          g && s.testimonialCardTitleFeatured
        )
      },
      e
    ), g ? /* @__PURE__ */ t.createElement("div", { className: s.testimonialCardFeaturedBody }, typeof c == "string" && c && /* @__PURE__ */ t.createElement(
      "div",
      {
        className: h(
          x.richText,
          x.textsBodyText,
          s.testimonialCardBody
        ),
        "data-testid": "testimonial-card-body",
        dangerouslySetInnerHTML: { __html: c }
      }
    ), c && typeof c != "string" && /* @__PURE__ */ t.createElement(
      "div",
      {
        className: h(
          x.richText,
          x.textsBodyText,
          s.testimonialCardBody
        ),
        "data-testid": "testimonial-card-body"
      },
      c
    ), l?.href && l.text && /* @__PURE__ */ t.createElement(
      ae,
      {
        className: h(
          O.PrimaryFocusStyleInLink,
          s.testimonialCardCta
        ),
        href: l.href,
        target: l.isExternalLink ? "_blank" : void 0,
        disableLinkTextStyle: !0,
        onClick: T,
        "data-analytics-click": "testimonials-cta",
        "data-analytics-label": e
      },
      /* @__PURE__ */ t.createElement(
        O.Primary,
        {
          text: l.text,
          asDiv: !0,
          className: s.testimonialCardCtaButton
        }
      )
    )) : /* @__PURE__ */ t.createElement("div", { className: s.testimonialCardTestimonialSection }, /* @__PURE__ */ t.createElement("div", { className: s.testimonialCardQuoteContainer }, /* @__PURE__ */ t.createElement("span", { className: s.testimonialCardQuoteMark }, "“"), /* @__PURE__ */ t.createElement("div", { className: s.testimonialCardTestimonialContent }, r && /* @__PURE__ */ t.createElement(
      "p",
      {
        className: h(
          x.textsBodyText,
          s.testimonialCardTestimonialText
        )
      },
      r
    ), (a || o) && /* @__PURE__ */ t.createElement("div", { className: s.testimonialCardAuthorInfo }, a && /* @__PURE__ */ t.createElement("span", { className: s.testimonialCardPersonName }, a), o && /* @__PURE__ */ t.createElement(
      "span",
      {
        className: h(
          x.textsBodyText,
          s.testimonialCardCompanyName
        )
      },
      o
    )))))))
  );
}, xe = "testimonials", Se = "testimonials--light-blue", Le = "testimonials--white", Oe = "testimonials--gray", ke = "testimonials--featured", Me = "testimonials__header", Pe = "desktop", Fe = "testimonials__title", Ie = "mobile", Ae = "testimonials__navigation", $e = "testimonials__carousel", De = "testimonials__carousel--featured", Re = "testimonials__mobile-list", Ge = "testimonials__mobile-card", We = "testimonials__load-more-container", f = {
  testimonials: xe,
  testimonialsLightBlue: Se,
  testimonialsWhite: Le,
  testimonialsGray: Oe,
  testimonialsFeatured: ke,
  testimonialsHeader: Me,
  desktop: Pe,
  testimonialsTitle: Fe,
  mobile: Ie,
  testimonialsNavigation: Ae,
  testimonialsCarousel: $e,
  testimonialsCarouselFeatured: De,
  testimonialsMobileList: Re,
  testimonialsMobileCard: Ge,
  testimonialsLoadMoreContainer: We
}, ze = 1216;
function Ve(e) {
  return window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
}
function Qe() {
  return window.innerWidth;
}
function at({
  id: e,
  title: r,
  testimonials: a,
  loadMoreText: o,
  backgroundColor: d = "lightBlue",
  variant: i = "quote",
  autoplay: c = !1
}) {
  const l = J(null), [C, _] = M(!1), [g, E] = M(!0), [T, S] = M(!1), [k, m] = M(2), u = K(
    Ve,
    Qe,
    () => 0
  ), p = z(() => u > N.xl, [u]), B = z(() => u < N.md, [u]), v = i === "featured", P = v || !B;
  F(() => {
    const n = l.current;
    if (!n)
      return;
    const y = () => {
      if (v)
        n.params.slidesOffsetBefore = 0, n.params.slidesOffsetAfter = 0;
      else if (p) {
        const W = (u - ze) / 2;
        n.params.slidesOffsetBefore = W, n.params.slidesOffsetAfter = W;
      }
      n.update();
      const G = !!c && (a?.length || 0) > 1;
      E(!G && n.isBeginning), S(
        !G && (!n.allowSlideNext || n.isEnd)
      );
    };
    if (y(), !n.el || typeof ResizeObserver > "u")
      return;
    const R = new ResizeObserver(y);
    return R.observe(n.el), () => R.disconnect();
  }, [
    C,
    u,
    p,
    c,
    v,
    a?.length
  ]), F(() => {
    m(B ? 2 : a?.length || 0);
  }, [B, a?.length]);
  const Q = U((n) => {
    if (n.params.loop) {
      E(!1), S(!1);
      return;
    }
    E(n.isBeginning), S(n.isEnd);
  }, []), $ = (n) => {
    const y = l.current;
    y && (n === "previous" ? y?.slidePrev() : y?.slideNext(), A("testimonials_navigate", {
      variant: i,
      direction: n,
      title: r
    }));
  }, q = () => {
    m(
      (n) => Math.min(n + 2, a?.length || 0)
    );
  }, b = a || [], H = B ? b.slice(0, k) : b, j = !P && B && k < b.length, X = !!(a && (v ? a.length > 1 : !B && a.length > 2)), D = c && P && b.length > 1;
  return F(() => {
    A("testimonials_impression", {
      variant: i,
      title: r,
      item_count: b.length
    });
  }, [r, i, b.length]), !a || a.length === 0 ? null : /* @__PURE__ */ t.createElement(
    L,
    {
      id: e,
      "data-testid": "testimonials-block",
      "data-variant": i,
      topPadding: L.Padding.SMALL,
      bottomPadding: L.Padding.LARGE,
      className: h(
        f.testimonials,
        d === "lightBlue" && f.testimonialsLightBlue,
        d === "white" && f.testimonialsWhite,
        d === "gray" && f.testimonialsGray,
        v && f.testimonialsFeatured
      )
    },
    /* @__PURE__ */ t.createElement(L.Content, { "data-testid": "testimonials-content" }, /* @__PURE__ */ t.createElement("div", { className: f.testimonialsHeader }, /* @__PURE__ */ t.createElement("h2", { className: h(f.testimonialsTitle) }, r), X && /* @__PURE__ */ t.createElement("div", { className: f.testimonialsNavigation }, /* @__PURE__ */ t.createElement(
      O.Arrow,
      {
        arrowDirection: "left",
        "aria-label": "Previous slide",
        "data-testid": "testimonials-prev",
        disabled: g,
        onClick: () => $("previous")
      }
    ), /* @__PURE__ */ t.createElement(
      O.Arrow,
      {
        arrowDirection: "right",
        "aria-label": "Next slide",
        "data-testid": "testimonials-next",
        disabled: T,
        onClick: () => $("next")
      }
    )))),
    /* @__PURE__ */ t.createElement(L.Content, { limitedWidth: v }, /* @__PURE__ */ t.createElement(
      "div",
      {
        className: h(
          f.testimonialsCarousel,
          v && f.testimonialsCarouselFeatured
        ),
        "data-testid": "testimonials-container"
      },
      /* @__PURE__ */ t.createElement(
        Z,
        {
          modules: D ? [ne] : [],
          slidesPerView: v ? 1 : "auto",
          spaceBetween: 20,
          slidesPerGroup: 1,
          centeredSlides: !1,
          speed: 500,
          loop: !1,
          autoplay: D ? {
            delay: 6e3,
            disableOnInteraction: !0,
            pauseOnMouseEnter: !0
          } : !1,
          watchOverflow: !0,
          preventClicks: !1,
          preventClicksPropagation: !1,
          touchStartPreventDefault: !1,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          onSlideChange: Q,
          onSwiper: (n) => {
            l.current = n, _(!0);
          },
          enabled: v,
          breakpoints: v ? {
            [N.sm]: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 20
            },
            [N.lg]: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 32
            }
          } : {
            [N.md]: {
              enabled: !0,
              slidesPerView: "auto",
              slidesPerGroup: 2,
              spaceBetween: 20,
              slidesOffsetBefore: 64,
              slidesOffsetAfter: 64
            },
            [N.lg]: {
              enabled: !0,
              slidesPerView: "auto",
              slidesPerGroup: 2,
              spaceBetween: 32,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80
            },
            [N.xl]: {
              enabled: !0,
              slidesPerView: "auto",
              slidesPerGroup: 2,
              spaceBetween: 32,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80
            }
          }
        },
        P ? /* @__PURE__ */ t.createElement(t.Fragment, null, a.map((n, y) => /* @__PURE__ */ t.createElement(w, { key: y, "data-testid": "testimonial-slide" }, /* @__PURE__ */ t.createElement(
          V,
          {
            ...n,
            variant: i,
            index: y + 1,
            total: a.length
          }
        )))) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: f.testimonialsMobileList }, H.map((n, y) => /* @__PURE__ */ t.createElement("div", { key: y, className: f.testimonialsMobileCard }, /* @__PURE__ */ t.createElement(
          V,
          {
            ...n,
            variant: i,
            index: y + 1,
            total: b.length
          }
        )))), j && /* @__PURE__ */ t.createElement("div", { className: f.testimonialsLoadMoreContainer }, /* @__PURE__ */ t.createElement(
          O.Primary,
          {
            text: o || "Load more",
            onClick: q,
            "data-testid": "testimonials-load-more"
          }
        )))
      )
    ))
  );
}
function nt(e) {
  const r = [...e];
  for (let a = r.length - 1; a > 0; a -= 1) {
    const o = Math.floor(Math.random() * (a + 1)), d = r[a];
    r[a] = r[o], r[o] = d;
  }
  return r;
}
export {
  V as TestimonialCard,
  at as Testimonials,
  nt as shuffleArray,
  A as trackTestimonialsEvent
};
//# sourceMappingURL=Testimonials.js.map
